import { render } from "./DialogUserCenter.vue?vue&type=template&id=094ea98e"
import script from "./DialogUserCenter.vue?vue&type=script&lang=js"
export * from "./DialogUserCenter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiuxiaofeng/Desktop/交接/assistant_eclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__